ACC.ordersLoader = {
  currentPageValue: 0,
  currentSortingValue: 'byDate',
  currentFilterValue: 'placedbyme',
  ordersJsonUrl: 'getSortedOrders.json',
  approvalOrdersJsonUrl: 'getApprovalOrders.json',
  getOrdersAjaxUrl: function() {
    var orderAjaxUrl = '';

    if (ACC.ordersLoader.currentFilterValue === 'placedbyme' || ACC.ordersLoader.currentFilterValue === 'none') {
      orderAjaxUrl = ACC.config.contextPath + ACC.ordersLoader.ordersJsonUrl + '?sort=' + ACC.ordersLoader.currentSortingValue +
      '&page=' + ACC.ordersLoader.currentPageValue + '&filter=' + ACC.ordersLoader.currentFilterValue;
    } else if (ACC.ordersLoader.currentFilterValue === 'needapproval') {
      orderAjaxUrl = ACC.config.contextPath + ACC.ordersLoader.approvalOrdersJsonUrl + '?sort=' + ACC.ordersLoader.currentSortingValue +
      '&page=' + ACC.ordersLoader.currentPageValue;
    }

    return orderAjaxUrl;
  },
  onSortingChanged: function(optionValue) {
    ACC.ordersLoader.currentSortingValue = optionValue;
  },
  onCheckPlacedbyME: function() {
    ACC.ordersLoader.currentFilterValue = 'placedbyme';
  },
  onNoFilters: function() {
    ACC.ordersLoader.currentFilterValue = 'none';
  },
  onCheckNeedsApproval: function() {
    ACC.ordersLoader.currentFilterValue = 'needapproval';
  },
  updatePageUrl: function() {
    var basepath = window.location.protocol + '//' + window.location.host,
        relativePath = window.location.href.replace(basepath, ''),
        newUrl = '/my-account/orders?sort=' + ACC.ordersLoader.currentSortingValue + '&filter=' + ACC.ordersLoader.currentFilterValue,
        obj = {
          sort: ACC.ordersLoader.currentSortingValue,
          page: ACC.ordersLoader.currentPageValue,
          filter: ACC.ordersLoader.currentFilterValue
        };

    if (relativePath.indexOf('orders?') > -1 && relativePath.indexOf('sort=') === -1) {
      newUrl = relativePath + '&sort=' + ACC.ordersLoader.currentSortingValue + '&filter=' + ACC.ordersLoader.currentFilterValue;
    }

    window.history.pushState(obj, document.title, newUrl);
  },
  decideFilter: function() {
    if ($('#placedbyme').is(':checked')) {
      ACC.ordersLoader.onCheckPlacedbyME();
    } else if ($('#needsmyapproval').is(':checked')) {
      ACC.ordersLoader.onCheckNeedsApproval();
    } else if ($('#placedbyme').length === 0) {
      ACC.ordersLoader.onCheckPlacedbyME();
    } else {
      ACC.ordersLoader.onNoFilters();
    }
  },
  getSortOptions: function(eventMode) {
    var phActiveClass = 'ph-active';

    if (eventMode === 'onclick') {
      $('.ph-sorting__item#sortingItem_byDate').trigger('click');
      $('.ph-orders-sorting__dropdown').removeClass(phActiveClass);
    }

    $.ajax({
      url: ACC.config.contextPath + 'getSortOptions.json?filter=' + ACC.ordersLoader.currentFilterValue,
      dataType: 'json',
      async: true,
      success: function(sortoptions) {
        var ulData = '',
            activeClass = '';

        for (var sortoptionCode in sortoptions) {
          if (sortoptionCode) {
            var sortoptionValue = sortoptions[sortoptionCode];

            if (sortoptionCode === ACC.ordersLoader.currentSortingValue) {
              activeClass = phActiveClass;
            } else {
              activeClass = '';
            }

            ulData = ulData + '<li class="ph-sorting__item ' + activeClass + '" sortcode="' + sortoptionCode + '" id="sortingItem_' + sortoptionCode + '">\n' +
                        '<div class="ph-sorting__itemcolor ph-sortingcolor_' + sortoptionCode + ' ph-' + sortoptionCode + '"></div>\n' +
                        '<div class="ph-sorting__itemtext ph-sortingtext_' + sortoptionCode + '">' + sortoptionValue + '</div>\n' +
                        '</li>';
          }
        }

        $('.ph-sorting__items').html(ulData);
      },
      error: function() {
        $('.ph-ordersfilter-loader').remove();
      }
    });
  },
  hideSearchResult: function() {
    $('.ph-freetextsearch__input').val('');
    $('.ph-freetextsearch__resultwrapper').addClass('ph-d-none');
    $(document).find('.ph-ordersControl .ph-filter').removeClass('ph-d-none');
    $('.ph-freetextsearch__checkbox').closest('.ph-filter').addClass('ph-d-none');

    if ($('#needsmyapproval').is(':checked')) {
      $('.ph-myApprovalOrders-data').removeClass('ph-d-none');
    } else {
      $('.ph-myOrders-data').removeClass('ph-d-none');
    }
  },
  initialize: function() {
    var basepath = window.location.protocol + '//' + window.location.host,
        relativePath = window.location.href.replace(basepath, ''),
        sortValueUrl = '',
        sortvalue = '',
        filtervalue = '';

    if (relativePath.indexOf('sort=') > -1) {
      sortValueUrl = relativePath.split('sort=')[1];
      sortvalue = sortValueUrl;
    }

    if (sortValueUrl !== '' && sortValueUrl.indexOf('&') > -1) {
      sortvalue = sortValueUrl.split('&')[0];
    }

    if (sortvalue !== '') {
      ACC.ordersLoader.currentSortingValue = sortvalue;
    }

    if (relativePath.indexOf('filter=') > -1) {
      filtervalue = relativePath.split('filter=')[1];
    }

    if (filtervalue !== '') {
      ACC.ordersLoader.currentFilterValue = filtervalue;
    }

    $('#ordersSortingSelect').attr('sortcode', ACC.ordersLoader.currentSortingValue)
      .html($('#sortingItem_' + ACC.ordersLoader.currentSortingValue).html());
  },
  bindAll: function() {
    var phOrdersSortingDropdown = 'ph-orders-sorting__dropdown',
        phActiveClass = 'ph-active';

    $('.' + phOrdersSortingDropdown).on('click keypress', function() {
      $(this).toggleClass(phActiveClass);
    });
    $('body,html').click(function(e) {
      if ($(e.target).closest('.' + phOrdersSortingDropdown).length === 0) {
        $('.' + phOrdersSortingDropdown + '.ph-active').removeClass(phActiveClass);
      }
    });
  }
};

$(document).ready(function() {
  if ($('.ph-orders-sorting').length > 0) {
    var basepath = window.location.protocol + '//' + window.location.host,
        relativePath = window.location.href.replace(basepath, ''),
        dropdown = $(document).find('.ph-orders-sorting__dropdown');

    ACC.ordersLoader.initialize();
    ACC.ordersLoader.bindAll();

    if (relativePath.indexOf('orderCode=') === -1) {
      ACC.ordersLoader.getSortOptions('onload');
      dropdown.removeClass('hidden');
    } else {
      $(document).find('.ph-orderhistory__container').removeClass('hidden');
      dropdown.addClass('hidden');
    }

    $('#placedbyme,#needsmyapproval').click(function() {
      ACC.ordersLoader.hideSearchResult();
      ACC.ordersLoader.decideFilter();
      ACC.ordersLoader.updatePageUrl();
      ACC.ordersLoader.getSortOptions('onclick');
    });
  }
});
